import { render, staticRenderFns } from "./fl44-unknown-volume-download-purchase-final-protocol-pdf-button.vue?vue&type=template&id=7b3602d4&"
import script from "./fl44-unknown-volume-download-purchase-final-protocol-pdf-button.vue?vue&type=script&lang=js&"
export * from "./fl44-unknown-volume-download-purchase-final-protocol-pdf-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b3602d4')) {
      api.createRecord('7b3602d4', component.options)
    } else {
      api.reload('7b3602d4', component.options)
    }
    module.hot.accept("./fl44-unknown-volume-download-purchase-final-protocol-pdf-button.vue?vue&type=template&id=7b3602d4&", function () {
      api.rerender('7b3602d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-download-purchase-final-protocol-pdf-button.vue"
export default component.exports